import { Box } from '@mui/material';

import { CLIENT_PORTAL_CONTENT } from '../../constants';

import {
  SectionContainer,
  ContentPaper,
  GridContainer,
  ImageBox,
  ImageBackground,
  PortalImage,
  ContentBox,
  ContentInner,
  PortalTitle,
  PortalSubtitle,
  PortalDescription,
  ButtonWrapper,
} from './styles';
import CTAButton from '../../../../../ui/ctaButton';

const ClientPortalSection = () => {
  return (
    <SectionContainer>
      <ContentPaper elevation={0}>
        <GridContainer>
          <ImageBox>
            <ImageBackground>
              <PortalImage
                component="img"
                alt={CLIENT_PORTAL_CONTENT.imageAlt}
                src={CLIENT_PORTAL_CONTENT.image}
                loading="lazy"
                decoding="async"
              />
            </ImageBackground>
          </ImageBox>

          <ContentBox>
            <ContentInner>
              <PortalTitle>{CLIENT_PORTAL_CONTENT.title}</PortalTitle>
              <PortalSubtitle>{CLIENT_PORTAL_CONTENT.subtitle}</PortalSubtitle>
              <Box>
                <PortalDescription dangerouslySetInnerHTML={{ __html: CLIENT_PORTAL_CONTENT.description }} />
              </Box>
            </ContentInner>
            <ButtonWrapper>
              <CTAButton
                text={CLIENT_PORTAL_CONTENT.buttonText}
                onClick={CLIENT_PORTAL_CONTENT.onClick}
              />
            </ButtonWrapper>
          </ContentBox>
        </GridContainer>
      </ContentPaper>
    </SectionContainer>
  );
};

export default ClientPortalSection;
